// extracted by mini-css-extract-plugin
export var pillWrapper = "_qo-0";
export var showOverflow = "_qo-1";